import { Component, Prop, Ref } from '@eastsideco/salvo-ts';
import { ThemeComponent } from "@/theme/ThemeComponent";
import SimpleParallax from 'simple-parallax-js';

@Component
export class HeroBanner extends ThemeComponent {
    @Ref({ required: false }) scrollImage!: HTMLElement[];
    @Prop({ default: 98 }) break!: number;
    @Prop({ default: 1.1 }) scale!: number;

    init() {
        this.handleImgAnimation();
    }

    protected handleImgAnimation() {
        if (!this.scrollImage) { return; }

        for (const image of this.scrollImage) {
            new SimpleParallax(image, {
                delay: 0,
                scale: this.scale,
                transition: 'linear',
                orientation: 'up',
                maxTransition: this.break
            });
        }

    }
}
